export default __webpack_public_path__ + "static/media/iranyekanwebbold.7df0faa4.eot";